export const getHasBarcodeDetector = (globalObject = window) => 'BarcodeDetector' in globalObject;
